import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  featuresBusinessHours: true,
  featuresCalendars: true,
  featuresModules: true,
  featuresMaxMilestone: 30,
  showHelpButtons: true,
};

// eslint-disable-next-line import/prefer-default-export
export const featuresSlice = createSlice({
  name: "features",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setFeaturesBusinessHours: (state, action) => {
      state.featuresBusinessHours = action.payload;
    },
    setFeaturesCalendars: (state, action) => {
      state.featuresCalendars = action.payload;
    },
    setFeaturesModules: (state, action) => {
      state.featuresModules = action.payload;
    },
    setFeaturesMaxMilestone: (state, action) => {
      state.featuresMaxMilestone = action.payload;
    },
    toggleHelpButtons: (state) => {
      state.showHelpButtons = !state.showHelpButtons;
    },
  },
});

export const {
  setFeaturesBusinessHours,
  setFeaturesCalendars,
  setFeaturesModules,
  setFeaturesMaxMilestone,
  toggleHelpButtons,
} = featuresSlice.actions;

export default featuresSlice.reducer;

export const selectFeatures = (state) => state.features;
export const isHelpButtonsVisible = (state) => state.features.showHelpButtons;
